"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pageLoadConstants = {
    countryCode: 'us',
    language: 'en',
    siteDescriptor: 'fas',
    platform: 'web',
    is404: 'N',
    DLVersion: '1.0'
};
exports.default = pageLoadConstants;
//# sourceMappingURL=pageLoad.constant.js.map